// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import { INFORMATION_ON_GRANTS } from "./formFields";

type OkpProjectInfoProps = {
  initialValues: {
    [INFORMATION_ON_GRANTS]: string
  },
  numberedWithDot?: boolean
};

export const GRANT_OPTIONS = {
  no_information_available: "Zum aktuellen Zeitpunkt liegen noch keine Informationen vor.",
  no_existing_grants:
    "Das Unternehmen oder mit dem Unternehmen verbundene Einheiten hat/haben als ein einziges Unternehmen im Sinne der de-minimis-Verordnungen in den letzten drei Jahren keine Beihilfen erhalten / beantragt.",
  existing_grants:
    'Nachfolgend bestätige ich, dass das Unternehmen oder mit dem Unternehmen verbundene Einheiten als "ein einziges Unternehmen" im Sinne der de-minimis-Verordnungen in den letzten drei Jahren Beihilfen erhalten / beantragt hat / haben.'
};

const OkpGrantsInfo = ({ initialValues, numberedWithDot }: OkpProjectInfoProps) => (
  <Section title="Beihilfe " reducedMargin numberedWithDot={numberedWithDot}>
    <EditableForm initialValues={initialValues} isLocked>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: INFORMATION_ON_GRANTS,
            caption: () => "Angaben zu erhaltenen und beantragten Beihilfen"
          }}
          displayValue={() => GRANT_OPTIONS[initialValues[INFORMATION_ON_GRANTS]]}
        />
      </FormRow>
    </EditableForm>
  </Section>
);

OkpGrantsInfo.defaultProps = {
  numberedWithDot: false
};

export default OkpGrantsInfo;
